/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function(event) {
    if (typeof updateColorOptions === 'function') {
        updateColorOptions();
    }
    if (typeof updatePaintMaterial === 'function') {
        updatePaintMaterial();
    }

});

document.addEventListener('theme:loading:end', function(event) {
    if (typeof theme.onCartUpdate === 'function') {
        theme.onCartUpdate();
    }
});

window.addEventListener('load', (event) => {
    if (typeof updatePaintMaterial === 'function') {
        updatePaintMaterial();
    }
    setImagePadding();
});

document.addEventListener('resize', function(event) {
    setImagePadding();
});

function setImagePadding(){
    var productSlideshow = document.querySelector('.Product__Slideshow');
    if (productSlideshow != null) {
      var productSlideshowWidth = productSlideshow.offsetWidth;
      var productSlideshowHeight = productSlideshow.offsetHeight;
      var slideImages = document.querySelectorAll('.Product__SlideItem img');
      slideImages.forEach((slideImage) => {
          var slideImageMaxWidth = slideImage.dataset.maxWidth;
          var slideImageMaxHeight = slideImage.dataset.maxHeight;
          if(slideImageMaxWidth < productSlideshowWidth && slideImageMaxHeight < productSlideshowHeight) {
              var targetWidthPadding = (productSlideshowWidth - slideImageMaxWidth) * 0.5;
              slideImage.style.paddingLeft = targetWidthPadding + 'px';
              slideImage.style.paddingRight = targetWidthPadding + 'px';
              var targetHeightPadding = (productSlideshowHeight - slideImageMaxHeight) * 0.5;
              slideImage.style.paddingTop = targetHeightPadding + 'px';
              slideImage.style.paddingBottom = targetHeightPadding + 'px';
          }
      });
    }
}
